export enum FileTypeEn {
  Pdf = 'pdf',
  Excel = 'xlsx',
  Doc = 'doc',
  Word = 'docx',
  Notepad = 'txt',
  Zip = 'zip',
  Mp4 = 'mp4',
  Mp3 = 'mp3'
}
